import { Hero } from '@/components/home/Hero'
import { Problems } from '@/components/home/Problems'
import { Solutions } from '@/components/home/Solutions'
import { Competencies } from '@/components/home/Competencies'
import { CTA } from '@/components/home/CTA'

export const HomePage = () => {
    return (
        <main>
            <Hero />
            <Problems />
            <Solutions />
            <Competencies />
            <CTA />
        </main>
    )
}

